import { UsersListRequest, UsersListResponse } from '../../../types/users'
import { useApiPostQuery } from '../useApi'

interface UseUsersListParams {
  CENTER_ID: number
  LEVEL?: string
  NAME?: string
  PHONE?: string
  STATE?: string
}

export const useUsersList = ({
  CENTER_ID,
  LEVEL = '',
  NAME = '',
  PHONE = '',
  STATE = '',
}: UseUsersListParams) => {
  const requestData: UsersListRequest = { CENTER_ID, LEVEL, NAME, PHONE, STATE }

  return useApiPostQuery<UsersListResponse>(
    '/users/list',
    ['usersList', requestData],
    requestData,
    !!CENTER_ID
  )
}
